/**
 * Fontstorage
 *
 * Declares a single web-accessible-resource group — `img/*.svg` — matched to `<all_urls>`
 * with no `use_dynamic_url`. Its UI icon SVGs are therefore fetchable from any page at a
 * fixed URL that carries the extension ID. Being images, they load through `probeImage`
 * with no CORS grant, so they survive a restrictive page CSP.
 *
 * Manifest verified against version 3.0.2.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lpfegdkicphlldcdfeomhdochopplghk';

export const fontstorage: ExtensionDefinition = {
  id: ID,
  name: 'Fontstorage',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'Exposes img/*.svg to every origin with no dynamic URL. The icon SVGs load via <img> ' +
    'without a CORS grant, so detection works even under a strict page CSP.',
  signals: [
    {
      id: 'war-link-svg',
      kind: 'web-accessible-resource',
      description:
        'Load img/link.svg via <img> — a UI icon exposed to every origin; needs no CORS ' +
        'grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'img/link.svg'),
    },
    {
      id: 'war-loader-svg',
      kind: 'web-accessible-resource',
      description: 'Load img/loader.svg via <img> — a second icon corroborating the first.',
      weight: 0.5,
      run: () => probeImage(ID, 'img/loader.svg'),
    },
    {
      id: 'war-arrowmore-svg',
      kind: 'web-accessible-resource',
      description: 'Load img/arrowmore.svg via <img> — a third independent icon path.',
      weight: 0.5,
      run: () => probeImage(ID, 'img/arrowmore.svg'),
    },
  ],
};
